<p>The connection between eFAACT Central and QuickBooks Online is terminated</p>
<p>In order to reconnect, log in to your eFAACT Central account and click the <b>Connect to QuickBooks</b> button</p>
